import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-about',
  templateUrl: './privacy-about.component.html',
  styleUrls: ['./privacy-about.component.css']
})
export class PrivacyAboutComponent {

}
